module.exports = __webpack_public_path__ + "img/gem2_color1.9094373e.png";